import React from "react";
import { Route, Switch } from "react-router-dom";
import TimesheetEntry from "./TimeSheet";
import AddCallOut from "./TimeSheetAddCallOut";
import CallOut from "./TimeSheetCallOut";
import TechnicianMonthView from "./TechnicianMonthView";
import HoursLogin from "./HoursLogin";
import CentralHoursLogin from "./HoursLogin/CentralRegion/";
import Profile from "../UserProfile";
const Techrouting = (props) => (
  <Switch>
    <Route
      path={`${props.match.path}/hoursadjustment&payment`}
      component={TimesheetEntry}
    />
    {props.security && (
      <Route
        path={`${props.match.path}/callouts`}
        render={() =>
          props.security.multiCallOuts === "Y" ? <AddCallOut /> : <CallOut />
        }
      />
    )}
    <Route
      path={`${props.match.path}/monthview`}
      component={TechnicianMonthView}
    />
    {props.security && (
      <Route
        path={`${props.match.path}/hourslogin`}
        render={() =>
          props.security.enableBreaksCal === "N" ? (
            <HoursLogin />
          ) : (
            <CentralHoursLogin />
          )
        }
      />
    )}
    <Route path={`${props.match.path}/profile`} component={Profile} />
  </Switch>
);

export default Techrouting;
